// extracted by mini-css-extract-plugin
export default {"header_wrapper":"Header_header_wrapper__lrgk4"};